export const PARKING_AVAILABILITY_API = `${process.env.DAP_BASE_URI}/parking/availability`;

export const PARKING_AVAILABILITY_RATES_API = `${process.env.DAP_BASE_URI}/parking/rates`;
